import { CUSTOM_PARTNER_UI_PAINT } from '@constants';

const extractCompanyKeyFromURL = () => {
  const paths = window.location.pathname.split('/');
  return paths.length > 2 ? paths[2] : '';
};

export const hasKeyOnCustomPartnerUIPaint = () => {
  const companyKey = extractCompanyKeyFromURL()
  return CUSTOM_PARTNER_UI_PAINT.has(companyKey)
}

export const isBrokerExternalLink = () => {
  const paths = window.location.pathname.split('/');
  return paths[1] === 'd'
}
